import 'bulma/css/bulma.min.css';
import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


interface Props {
    placeHolder: string;
    getSearchResults: any;
}

function SearchBar(props: Props) {

    const searchStyle = {
        inputDiplay: {
            marginRight: "10px",
            marginBottom: "6px"
        },

        inputFont: {
            fontSize: "1rem"
        }
    };

    const [searchPhrase, setSearchPhrase] = useState('');
   
    function updateSearchPhrase(event: any) {
        setSearchPhrase(event.target.value);
        //empty search bar would trigger a search to display the initial payload
        if (event.target.value.trim() == "") {
            props.getSearchResults("");
        }
    }

    function getSearchResults() {
        props.getSearchResults(searchPhrase);
    }

    function enterKeySearch(event: any) {
        if (event.charCode === 13) {
            getSearchResults();
        }
    }

    return (
        <div className="control has-icons-right" style={searchStyle.inputDiplay}>
            <input
                onChange={updateSearchPhrase}
                onKeyPress={enterKeySearch}
                style={searchStyle.inputFont}
                className="input is-info"
                type="text"
                placeholder={props.placeHolder} />
            <span className="icon is-right is-clickable">
                <FontAwesomeIcon icon={["fas", "search"]} onClick={getSearchResults} />
            </span>
        </div>
    );
}

export default SearchBar;